<template>
<article class="profile-container" v-if="model">
    <image-viewer :images="getImages()" :thumbnails="getImageThumbnails()" :placeholder="placeholder()"></image-viewer>

    <section id="profileContent">
        <div class="header">
            <p class="subheader">{{ model.NamTitle }}</p>
            <h1 class="profileHeader">{{ name(model) }}</h1>
            <a href="#medals" v-if="medals && medals.length > 0" class="medal-link">
                <img v-for="medal in medals"
                    :key="medal.name"
                    :src="medal.media[0].sizes ? 
                    medal.media[0].sizes.thumb.url : medal.media[0].url ? 
                    medal.media[0].url : ''"
                    class="lift-hover">
            </a>
        </div>
        <div id="info">
            <div class="data">
                <p class="label">{{ $t('labels.units') }}</p>
                <p class="field">{{ units(model) }}</p>
            </div>
            <div class="data">
                <p class="label">{{ $t('labels.branch') }}</p>
                <p class="field">{{ branch(model) }}</p>
            </div>
            <div class="data">
                <p class="label">{{ $t('labels.service_component') }}</p>
                <p class="field">{{ services(model) }}</p>
            </div>
            <div class="data">
                <p class="label">{{ $t('labels.service_numbers') }}</p>
                <p class="field">{{ serviceNos(model) }}</p>
            </div>
            <div class="data">
                <p class="label">{{ $t('labels.birth') }}</p>
                <p class="field" v-if="model.BioBirthDate">{{ model.BioBirthDate }}</p>
                <p class="field" v-if="model.BioBirthPlace">{{ model.BioBirthPlace }}</p>
            </div>
            <div class="data">
                <p class="label">{{ $t('labels.death') }}</p>
                <p class="field" v-if="model.BioDeathDate">{{ model.BioDeathDate }}</p>
                <p class="field" v-if="model.BioDeathPlace">{{ model.BioDeathPlace }}</p>
            </div>
            <div class="data">
                <p class="label">{{ $t('labels.grave') }}</p>
                <p class="field" v-if="model.BioBurialPlace">{{ model.BioBurialPlace }}</p>
            </div>
            <div class="data">
                <p class="label">{{ $t('labels.gender') }}</p>
                <p class="field">{{ model.NamSex }}</p>
            </div>
        </div>

        <div id="about">
            <b class="body" v-html="biography(model)"></b>
        </div>
    </section>
</article>

</template>

<script>
import * as recipient from '@/models/recipient.js'

import ImageViewer from '@/components/ImageViewer'


export default {
    name: "Profile",
    components: {
        ImageViewer
    },
    props: {
        model: Object,
        medals: Array
    },
    methods: {
        name: (item => {
            return recipient.recipient_name(item)
        }),
        largeImage: (item => {
            return recipient.recipient_large_image(item)
        }),
        images: (item => {
            return recipient.recipient_images(item)
        }),
        thumbnails: (item => {
            return recipient.recipient_image_thumbnails(item)
        }),
        units: (item => {
            return recipient.recipient_units(item)
        }),
        branch: (item => {
            return recipient.recipient_branch(item)
        }),
        services: (item => {
            return recipient.recipient_services(item)
        }),
        serviceNos: (item => {
            return recipient.recipient_service_numbers(item)
        }),
        biography: (item => {
            return recipient.recipient_biography(item)
        }),
        placeholder: function () {
            if (this.largeImage(this.model)) {
                return {};
            } else {
                return {
                    url: `${this.$rootUrl()}/images/baseline-person-24px.svg`,
                    alt: `${this.$i18n.t('recipient_detail_page.placeholder_alt')}`
                };
            }

        },
        getImages: function () {
            let images = [];
            if (this.largeImage(this.model)) { images.push(this.largeImage(this.model)); }

            if (this.images(this.model)) {
                images.splice(images.length + 1, 0, ...this.images(this.model));
            }

            // rename properties to match vue-easy-lightbox api
            return images.map(img => { return {src: img.url, title: img.caption}; })
        },
        getImageThumbnails: function () {
            let images = [];
            if (this.largeImage(this.model)) { images.push(this.largeImage(this.model)); }

            if (this.thumbnails(this.model)) {
                images.splice(images.length + 1, 0, ...this.thumbnails(this.model));
            }

            // rename properties to match vue-easy-lightbox api
            return images.map(img => { return {src: img.url, title: img.caption}; })
        }
    }
}
</script>

<style lang="scss" scoped>
.medal-link {
    position: relative;
    transition: all 300ms ease-out;


    img {
        height: 100px;
        width: auto;
        margin-right: 8px;
        position: relative;
        border: solid black 1px;
    }
}

@media screen and (max-width: 980px) and (min-width: 850px){
    .medal-link img {
        height: 75px;
    }
}

</style>